export const themeChangeSettings = (settings) => ({
  type: 'THEME_CHANGE_TYPE',
  payload: settings,
});
